export const BEFORE_FETCH_SETTINGS_DATA = 'BEFORE_FETCH_SETTINGS_DATA';
export const FETCH_SETTINGS_DATA = 'FETCH_SETTINGS_DATA';
export const NETWORK_ERROR_FETCHING_SETTINGS_DATA = 'NETWORK_ERROR_FETCHING_SETTINGS_DATA';